import { QBankStructureStatus } from '@exam-management/graphql';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Button, EditOutlinedIcon } from '@shared/components';
import { WithPermission } from '@shared/permissions';
import { useOutletContext } from 'react-router-dom';

import { QBankStructureLevelItemFormAction } from '../../constants';
import type { ActionOutletContextType } from '../../types';

interface QBankStructureLevelItemListActionProps {
  onEdit: () => void;
}

const HIDE_EDIT_STATUSES = [
  QBankStructureStatus.Draft,
  QBankStructureStatus.Published,
  QBankStructureStatus.Archived,
];

export default function QBankStructureLevelItemListAction(
  props: Readonly<QBankStructureLevelItemListActionProps>,
) {
  const { onEdit } = props;

  const { qBankStructureInformation } = useQBankStructure();
  const { action } = useOutletContext<ActionOutletContextType>();

  const isEditing = action === QBankStructureLevelItemFormAction.EDIT;
  const isNotAllowEdit =
    qBankStructureInformation && HIDE_EDIT_STATUSES.includes(qBankStructureInformation.status);

  if (isNotAllowEdit || isEditing) return null;

  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.QBANK.STRUCTURE.UPDATE}>
      <Button
        variant='outlined'
        sx={{
          minWidth: 'auto',
        }}
        color='secondary'
        startIcon={<EditOutlinedIcon />}
        onClick={onEdit}
      >
        Edit Structure
      </Button>
    </WithPermission>
  );
}
